// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.accessibility-statement {
    font-weight: 300;
    font-size: 15px;
    line-height: 20px;
    margin: 25px;

    color: #000000;

    p {
        margin-bottom: 30px;
    }
}


.accessibility-statement-subheader {
    font-weight: 700;
    font-size: 24px;
    line-height: 31px;

    color: #000000;
}


@media only screen and (min-width: 450px) {
    .accessibility-container {
        flex-direction: column;
        justify-content: center;
        align-items: center;
        display: flex;
    }

    .accessibility-statement {
        width: 85%;
        background: #FFFFFF;
        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.21);
        border-radius: 25px;
        padding: 30px;
        z-index: 1;
        flex-direction: column;
        margin-top: -50px;
    }
}`, "",{"version":3,"sources":["webpack://./src/AccessibilityStatement.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;;IAEZ,cAAc;;IAEd;QACI,mBAAmB;IACvB;AACJ;;;AAGA;IACI,gBAAgB;IAChB,eAAe;IACf,iBAAiB;;IAEjB,cAAc;AAClB;;;AAGA;IACI;QACI,sBAAsB;QACtB,uBAAuB;QACvB,mBAAmB;QACnB,aAAa;IACjB;;IAEA;QACI,UAAU;QACV,mBAAmB;QACnB,2CAA2C;QAC3C,mBAAmB;QACnB,aAAa;QACb,UAAU;QACV,sBAAsB;QACtB,iBAAiB;IACrB;AACJ","sourcesContent":[".accessibility-statement {\n    font-weight: 300;\n    font-size: 15px;\n    line-height: 20px;\n    margin: 25px;\n\n    color: #000000;\n\n    p {\n        margin-bottom: 30px;\n    }\n}\n\n\n.accessibility-statement-subheader {\n    font-weight: 700;\n    font-size: 24px;\n    line-height: 31px;\n\n    color: #000000;\n}\n\n\n@media only screen and (min-width: 450px) {\n    .accessibility-container {\n        flex-direction: column;\n        justify-content: center;\n        align-items: center;\n        display: flex;\n    }\n\n    .accessibility-statement {\n        width: 85%;\n        background: #FFFFFF;\n        box-shadow: 1px 2px 5px rgba(0, 0, 0, 0.21);\n        border-radius: 25px;\n        padding: 30px;\n        z-index: 1;\n        flex-direction: column;\n        margin-top: -50px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
